import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import {GenericConfigurationForm, FormItem, validateFormData} from 'src/components/GenericConfigurationForm';

interface FunctionalEnrichmentParametersProps {
    formData: any;
    setFormData: (data: any) => void;
    setValidForm: (isValid: boolean) => void;
}

const items: Readonly<FormItem>[] = [
    {
        name: 'ontology',
        humanReadableName: 'Ontology',
        description: 'Select which Gene Ontology (GO) domain to analyze.',
        // longDescription: '',
        selects: [
            {value: 'ALL', label: 'All'},
            {value: 'BP', label: 'BP'},
            {value: 'MF', label: 'MF'},
            {value: 'CC', label: 'CC'}
        ]
    },
    {
        name: 'p_adjust_method',
        humanReadableName: 'pAdjustMethod',
        description: 'Choose the method used to adjust p-values for multiple testing.',
        // longDescription: '',
        selects: [
            {value: 'bonferroni', label: 'Bonferroni'},
            {value: 'hochberg', label: 'Hochberg'},
            {value: 'holm', label: 'Holm'},
            {value: 'hommel', label: 'Hommel'},
            {value: 'BH', label: 'BH'},
            {value: 'BY', label: 'BY'},
            {value: 'fdr', label: 'FDR'},
            {value: 'none', label: 'None'}
        ]
    },
    {
        name: 'q_value_cutoff',
        humanReadableName: 'qvalueCutoff',
        description: 'Set the significance threshold for adjusted p-values (q-values).',
        // longDescription: '',
        numbers: {
            min: 0,
            max: 1,
            step: 0.01
        }
    }
];

export const FunctionalEnrichmentParameters = ({formData, setFormData, setValidForm}: FunctionalEnrichmentParametersProps) => {
    const handleInputChange = (values: Record<string, any>) => {
        setFormData((prevData: any) => ({
            ...prevData,
            functional_enrichment_analysis: {
                ...prevData.functional_enrichment_analysis,
                ...values
            }
        }));
    };

    const [errors, setErrors] = useState<Record<string, string>>({});

    useEffect(() => {
        const newErrors = validateFormData(formData.functional_enrichment_analysis, items);
        setErrors(newErrors);
        setValidForm(Object.keys(newErrors).length === 0);
    }, [formData, setValidForm]);

    return (
        <Box
            p={3}
            my={1}
            sx={{borderRadius: '10px', bgcolor: 'surface-container-lowest', display: 'flex', flexDirection: 'column', gap: 3}}>
            <GenericConfigurationForm
                items={items}
                itemValues={formData.functional_enrichment_analysis}
                setItemValues={handleInputChange}
                itemErrors={errors}
            />
        </Box>
    );
};
